"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchSurveyAnswerWorker = watchSurveyAnswerWorker;
exports.default = watchSurveyAnswer;
const js_1 = __importDefault(require("@bugsnag/js"));
const effects_1 = require("redux-saga/effects");
const leadSurvey_1 = require("../../../slices/leadSurvey");
const sendAnswer_1 = __importDefault(require("./fetchers/sendAnswer"));
function* watchSurveyAnswerWorker(action) {
    yield (0, effects_1.delay)(300);
    try {
        const leadSurveyId = yield (0, effects_1.select)((state) => state.leadSurvey.leadSurveyId);
        yield (0, effects_1.call)(sendAnswer_1.default, {
            responses: action.payload.responses,
            leadSurveyId,
            questionId: action.payload.question_id
        });
        yield (0, effects_1.put)((0, leadSurvey_1.sendAnswersSuccess)());
    }
    catch (error) {
        js_1.default.notify(error);
        yield (0, effects_1.put)((0, leadSurvey_1.sendAnswersFailure)('errors:unknownError'));
    }
}
function* watchSurveyAnswer() {
    yield (0, effects_1.takeLatest)(leadSurvey_1.sendAnswers, watchSurveyAnswerWorker);
}
//# sourceMappingURL=index.js.map